/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceCurrencyDTO
 */
export interface PriceCurrencyDTO {
    /**
     * 
     * @type {string}
     * @memberof PriceCurrencyDTO
     */
    countryName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PriceCurrencyDTO
     */
    isoCountryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PriceCurrencyDTO
     */
    countryCurrency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PriceCurrencyDTO
     */
    price?: number;
}

/**
 * Check if a given object implements the PriceCurrencyDTO interface.
 */
export function instanceOfPriceCurrencyDTO(value: object): value is PriceCurrencyDTO {
    return true;
}

export function PriceCurrencyDTOFromJSON(json: any): PriceCurrencyDTO {
    return PriceCurrencyDTOFromJSONTyped(json, false);
}

export function PriceCurrencyDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceCurrencyDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'countryName': json['countryName'] == null ? undefined : json['countryName'],
        'isoCountryCode': json['isoCountryCode'] == null ? undefined : json['isoCountryCode'],
        'countryCurrency': json['countryCurrency'] == null ? undefined : json['countryCurrency'],
        'price': json['price'] == null ? undefined : json['price'],
    };
}

export function PriceCurrencyDTOToJSON(json: any): PriceCurrencyDTO {
    return PriceCurrencyDTOToJSONTyped(json, false);
}

export function PriceCurrencyDTOToJSONTyped(value?: PriceCurrencyDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'countryName': value['countryName'],
        'isoCountryCode': value['isoCountryCode'],
        'countryCurrency': value['countryCurrency'],
        'price': value['price'],
    };
}

